import { useMutation, useQueryClient } from '@tanstack/react-query'
import { TrainingsProxy } from '../api'
import {
	removeTrainingFromCachedLists,
	scheduleTrainingListsInvalidation,
} from '../model/cache'
import { toast } from 'sonner'
import { DeleteTrainingResponse } from '@entities/training/types/create'

function deleteTrainingRequest(workoutId: number): Promise<DeleteTrainingResponse> {
	return TrainingsProxy.deleteTraining(workoutId)
}

export const useDeleteTraining = () => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: deleteTrainingRequest,
		onSuccess: (_data, workoutId) => {
			toast.success('Тренировка успешно удалена', {
				position: 'top-right',
				duration: 3000,
			})
			removeTrainingFromCachedLists(queryClient, workoutId)
			scheduleTrainingListsInvalidation(queryClient)
		},
		onError: () => {
			toast.error('Не удалось удалить тренировку', {
				position: 'top-right',
				duration: 3000,
				className: 'text-red-300',
			})
		},
	})
}
